export default __webpack_public_path__ + "static/media/68.a06148c7.jpeg";